<template>
  <div id="investor">
    <vx-card v-if="isMounted && !failed" class="mt-2">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full">
            <vs-select
              placeholder="Seleccione"
              label="Proyecto"
              class="w-full"
              v-model="projectFilterSelected">
              <vs-select-item :value="item.id" :text="item.alias" v-for="item in allData.projects" />
            </vs-select>
        </div>
        <div class="vx-col sm:w-1/5 w-full mb-4">
          <label class="vs-input--label">Fecha de inicio</label>
          <datepicker
            placeholder="Fecha inicio"
            :language="es"
            v-model="startDate"
            format="dd/MM/yyyy"
            :disabledDates="disabledDates"
          />
        </div>
        <div class="vx-col sm:w-1/5 w-full mb-4">
          <label class="vs-input--label">Fecha de término:</label>
          <datepicker
            placeholder="Fecha final"
            :language="es"
            v-model="endDate"
            format="dd/MM/yyyy"
            :disabledDates="disabledDates"
          />
        </div>
        <div class="vx-col sm:w-3/5 w-full mb-4 flex">
          <vs-button @click="datesChanged" color="primary" style="height: 40px" class="mt-6 mr-1 px-3">Consultar</vs-button>
        </div>
      </div>

      <vs-table :sst="true" @sort="handleSort" ref="table" stripe :max-items="30" :data="allMovements" noDataText="No hay datos disponibles">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <!-- ITEMS PER PAGE -->
          <div class="p-3 mb-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">Mostrando {{ from }} - {{ to }} de {{ totalRecords }}</span>
          </div>
        </div>

        <template slot="thead">
          <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx">{{col.title}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
            <vs-td>{{ dateTimeFormat(tr.created_at) }}</vs-td>
            <vs-td>{{ tr.concept }}</vs-td>
            <vs-td>{{ tr.reference }}</vs-td>
            <vs-td>{{ costFormat(tr.income) }}</vs-td>
            <vs-td>{{ costFormat(tr.outcome) }}</vs-td>
            <vs-td>{{ costFormat(tr.final_balance) }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <br>
      <vs-pagination :total="totalPages" v-model="currentx"></vs-pagination>
      <!--div class="pager" v-if="allMovements.length > 0">
        <div class="flex flex-wrap">
            <vs-button radius @click="pager(allData.first_page_url)" class="mr-2 px-3"> << </vs-button>
            <vs-button radius @click="pager(allData.prev_page_url)" class="mr-2m px-3">{{"<"}}</vs-button>
            <vs-button radius class="mr-2 px-5">{{allData.current_page}}</vs-button>
            <vs-button radius @click="pager(allData.next_page_url)" class="mr-2 px-3">{{">"}}</vs-button>
            <vs-button radius @click="pager(allData.last_page_url)" class="mr-2 px-3">{{">>"}}</vs-button>
        </div>
      </div-->
    </vx-card>
  </div>
</template>

<script>
import formatHelper from '@mixins/formatHelper';
import dateHelper from '@mixins/dateHelper';
import Datepicker from 'vuejs-datepicker';
import { es } from "vuejs-datepicker/dist/locale";

const columnDefinitions = [
  { title: "FECHA", key: "date", sortable: true },
  { title: "CONCEPTO", key: "concept", sortable: true },
  { title: "REFERENCIA", key: "reference", sortable: true },
  { title: "INGRESO", key: "income", sortable: true },
  { title: "EGRESO", key: "outcome", sortable: true },
  { title: "SALDO", key: "balance", sortable: true }
];

export default {
  mixins: [formatHelper, dateHelper],
  components: {
    Datepicker
  },
  async mounted() {
    this.setInitialDates();
    await this.loadMovements(1);
  },
  props: {
    InvestorId: {
      type: [String,Number],
      required: true
    }
  },
  data() {
    return {
      es: es,
      allData: [],
      orderKey: "",
      startDate: null,
      endDate: null,
      columns: columnDefinitions,
      isMounted: false,
      loading: false,
      failed: false,
      disabledDates: {
        from: new Date()
      },
      currentx: 1,
      initialDateRange: 30,
      maxRangeDays: 365,
      isInvalidRange: false,
      rangeError: "El rango de tiempo máximo para consulta o descarga es de 1 año.",
      projectFilterSelected: 'all',
    };
  },
  computed: {
    allMovements(){
      return this.allData.data || [];
    },
    from(){
      return this.allData.from;
    },
    to(){
      return this.allData.to;
    },
    totalRecords(){
      return this.allData.total;
    },
    totalPages(){
      return Math.ceil(this.allData.total / this.allData.per_page);
    }
  },
  watch: {
    loading: function(){
      if(this.loading) {
        this.$vs.loading();
      }
      else {
        this.$vs.loading.close();
      }
    },
    currentx: async function (newv, oldv){
      await this.pager(newv);
    }
  },
  methods: {
    async goToStatementsPage(){
      await this.$router.push({name: 'estadosCuentaInversionista'});
    },
    setInitialDates(){
      let sdate = new Date();
      sdate.setDate(sdate.getDate() - this.initialDateRange);
      this.startDate = sdate;
      this.endDate = new Date();
    },
    async loadMovements(page){
      this.isMounted = false;
      this.loading = true;
      this.failed = false;
      try {
        let data = {
          start: this.startDate,
          end: this.endDate,
          project_id: this.projectFilterSelected
        }
        let url = `/api/v2/investor/${this.InvestorId}/movementsList?page=${page}`;
        let response = await axios.post(url, data);
        this.allData = response.data;
        this.allData.projects.unshift({id: 'all', alias: 'Todos'});
        this.allMovements.forEach(movement => {
          let nn = movement.trx_type.substr(1, 1);
          movement.date = new Date(movement.created_at);
          if(nn != "1"){
            movement.type = "charge";
            movement.outcome = movement.amount;
          }
          else {
            movement.type = "deposit";
            movement.income = movement.amount;
          }
        });
      } catch (e) {
        this.failed = true;
      }
      this.isMounted = true;
      this.loading = false;
    },
    async datesChanged() {
      const valid = this.validateDates();
      if(valid){
        await this.loadMovements(1);
        this.currentx = 1;
      }
    },
    async restoreRecords() {
      await this.loadMovements(1);
      this.currentx = 1;
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`)
    },
    async pager(page){
      await this.loadMovements(page);
    },
    async downloadCSV(){
      const valid = this.validateDates();
      if(!valid){
        return;
      }

      try {
        const startYear = this.startDate.getFullYear();
        const startMonth = this.startDate.getMonth() + 1;
        const startDay = this.startDate.getDate();
        const endYear = this.endDate.getFullYear();
        const endMonth = this.endDate.getMonth() + 1;
        const endDay = this.endDate.getDate();
        let params = `startYear=${startYear}&startMonth=${startMonth}&startDay=${startDay}&endYear=${endYear}&endMonth=${endMonth}&endDay=${endDay}&projectId=${this.projectFilterSelected}`;
        let url = `${this.ApiDomain}/api/v2/investor/${this.InvestorId}/movementsListCSV?access_token=${this.AccessToken}&${params}`;
        window.open(url, "_blank");
      }
      catch (e) {
        this.warn(e)
      }
    },
    validateDates(){
      this.isInvalidRange = false;
      if(this.startDate > this.endDate){
        this.isInvalidRange = true;
        this.errorNotifDialog("Aviso", "La fecha de inicio no puede ser mayor a la fecha de término.")
        return false;
      }
      const diffTime = Math.abs(this.startDate - this.endDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if(diffDays > this.maxRangeDays){
        this.isInvalidRange = true;
        this.errorNotifDialog("Aviso", this.rangeError);
        return false;
      }
      return true;
    },
    downloadCSVLocal(){
      let array = [];
      array.push(['Fecha', 'Concepto', 'Referencia', 'Ingreso', 'Egreso', 'Saldo']);
      this.allMovements.forEach(f => {
        array.push([f.created_at, f.concept, f.reference, f.income, f.outcome, f.final_balance]);
      });

      let str = '';
      for (let i = 0; i < array.length; i++) {
        let line = '';
        line = array[i].join(",");
        str += line + '\r\n';
      }
      let blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });

      let link = document.createElement('a');
      let url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'movimientos.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
};
</script>

